<template>
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
      </b-col>
    </b-row>

    <b-row v-if="sale">
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de la Pre-Venta</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="2">
                <strong>Correlativo:</strong>
                <p>{{ sale.quote ? sale.quote.correlative : 'No disponible' }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Documento del Cliente:</strong>
                <p>{{ sale.quote ? sale.quote.clientDni : 'No disponible' }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Cliente:</strong>
                <p>{{ sale.quote ? sale.quote.clientName : 'No disponible' }}</p>
              </b-col>
              <!--<b-col sm="6" lg="2">
                <strong>Venta realizada por:</strong>
                <p>{{ sale.registerBy ? sale.registerBy.fullname : 'No asignado' }}</p>
              </b-col>-->
              <b-col sm="6" lg="2">
                <strong>Establecimiento Origen:</strong>
                <p>{{ sale.establishmentOrigin ? sale.establishmentOrigin.name : 'No disponible' }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Tipo de moneda:</strong>
                <p>{{ sale.quote.currencyType }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalle de la Pre-Venta</h4>
          </b-card-header>
          <b-card-text>
            <b-table
              :items="saleDetails"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="No existen detalles"
            />
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import SaleService from "@/services/SaleService";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      sale: null,
      saleDetails: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: "autopart.AutopartBrand.name", label: "Marca Autoparte", sortable: true },
        { key: "autopart.originalCode", label: "Código Original", sortable: true },
        { key: "autopart.alterCode", label: "Código Alterno", sortable: true },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: true },
        { key: "unitPrice", label: "Precio Unitario", sortable: true },
      ],
    };
  },
  mounted() {
    this.getSaleDetails();
  },
  methods: {
    async getSaleDetails() {
      try {
        const saleId = this.$route.params.id; 
        const store = this.$store;
        const response = await SaleService.getSaleById(saleId, store);

        if (response && response.statusCode === 200 && response.data) {
          this.sale = response.data.sale;
          this.saleDetails = response.data.saleDetails;
        } else {
          this.$swal("Error", "No se encontraron detalles de la venta.", "error");
        }
      } catch (error) {
        console.error("Error al obtener la venta:", error);
        this.$swal("Error", "Ocurrió un problema al cargar los detalles de la venta.", "error");
      }
    },
  },
};
</script>
